// DO NOT MODIFY BY HAND!!
// Go through Readme.md

import React from 'react';

import { ReactComponent as CorporateBond } from './icon-CorporateBond.svg';
import { ReactComponent as Docs } from './icon-Docs.svg';
import { ReactComponent as Home } from './icon-Home.svg';
import { ReactComponent as IPO } from './icon-IPO.svg';
import { ReactComponent as Money } from './icon-Money.svg';
import { ReactComponent as Money2 } from './icon-Money2.svg';
import { ReactComponent as Nominee } from './icon-Nominee.svg';
import { ReactComponent as OnlineEmpanelment } from './icon-OnlineEmpanelment.svg';
import { ReactComponent as Protection } from './icon-Protection.svg';
import { ReactComponent as Review } from './icon-Review.svg';
import { ReactComponent as SIPs } from './icon-SIPs.svg';
import { ReactComponent as STPs } from './icon-STPs.svg';
import { ReactComponent as SWPs } from './icon-SWPs.svg';
import { ReactComponent as Watchlist } from './icon-Watchlist.svg';
import { ReactComponent as AddClient } from './icon-addClient.svg';
import { ReactComponent as Advisor } from './icon-advisor.svg';
import { ReactComponent as AggressiveHybrid } from './icon-aggressiveHybrid.svg';
import { ReactComponent as Analysis } from './icon-analysis.svg';
import { ReactComponent as Arbitrage } from './icon-arbitrage.svg';
import { ReactComponent as Balance } from './icon-balance.svg';
import { ReactComponent as BalancedAdvantage } from './icon-balancedAdvantage.svg';
import { ReactComponent as Bank } from './icon-bank.svg';
import { ReactComponent as Bank2 } from './icon-bank2.svg';
import { ReactComponent as BikeInsurance } from './icon-bikeInsurance.svg';
import { ReactComponent as BizGuru } from './icon-bizGuru.svg';
import { ReactComponent as Brokerage } from './icon-brokerage.svg';
import { ReactComponent as BusinessLoan } from './icon-businessLoan.svg';
import { ReactComponent as BuyAPolicy } from './icon-buyAPolicy.svg';
import { ReactComponent as Calculator } from './icon-calculator.svg';
import { ReactComponent as Calendar } from './icon-calendar.svg';
import { ReactComponent as Car } from './icon-car.svg';
import { ReactComponent as CarInsurance } from './icon-carInsurance.svg';
import { ReactComponent as CarLoan } from './icon-carLoan.svg';
import { ReactComponent as CasUpload } from './icon-cas-upload.svg';
import { ReactComponent as Cash } from './icon-cash.svg';
import { ReactComponent as Chair } from './icon-chair.svg';
import { ReactComponent as ChannelPlus } from './icon-channelPlus.svg';
import { ReactComponent as Chart } from './icon-chart.svg';
import { ReactComponent as ClaimCentre } from './icon-claimCentre.svg';
import { ReactComponent as CoinStack } from './icon-coinStack.svg';
import { ReactComponent as Commodities } from './icon-commodities.svg';
import { ReactComponent as Compare } from './icon-compare.svg';
import { ReactComponent as Compare2 } from './icon-compare2.svg';
import { ReactComponent as CompareFunds } from './icon-compareFunds.svg';
import { ReactComponent as ComparePolicies } from './icon-comparePolicies.svg';
import { ReactComponent as Conservative } from './icon-conservative.svg';
import { ReactComponent as ConservativeHybrid } from './icon-conservativeHybrid.svg';
import { ReactComponent as Cross } from './icon-cross.svg';
import { ReactComponent as CsvUpload } from './icon-csv-upload.svg';
import { ReactComponent as CustomerSupport } from './icon-customerSupport.svg';
import { ReactComponent as Digikyc } from './icon-digikyc.svg';
import { ReactComponent as Dividend } from './icon-dividend.svg';
import { ReactComponent as DividendYield } from './icon-dividendYield.svg';
import { ReactComponent as Doc } from './icon-doc.svg';
import { ReactComponent as EducationLoan } from './icon-educationLoan.svg';
import { ReactComponent as ExpertSupport } from './icon-expertSupport.svg';
import { ReactComponent as Explore } from './icon-explore.svg';
import { ReactComponent as Faq } from './icon-faq.svg';
import { ReactComponent as Faq2 } from './icon-faq2.svg';
import { ReactComponent as Filter } from './icon-filter.svg';
import { ReactComponent as FixedDeposit } from './icon-fixedDeposit.svg';
import { ReactComponent as FlexiCap } from './icon-flexiCap.svg';
import { ReactComponent as Flexible } from './icon-flexible.svg';
import { ReactComponent as Focus } from './icon-focus.svg';
import { ReactComponent as Friendly } from './icon-friendly.svg';
import { ReactComponent as FundFinder } from './icon-fundFinder.svg';
import { ReactComponent as Gift } from './icon-gift.svg';
import { ReactComponent as Goal } from './icon-goal.svg';
import { ReactComponent as Gold } from './icon-gold.svg';
import { ReactComponent as GraduateBoy } from './icon-graduate-boy.svg';
import { ReactComponent as GraduateGirl } from './icon-graduate-girl.svg';
import { ReactComponent as GraduationBoy } from './icon-graduationBoy.svg';
import { ReactComponent as GraduationGirl } from './icon-graduationGirl.svg';
import { ReactComponent as Health } from './icon-health.svg';
import { ReactComponent as HealthInsurance } from './icon-healthInsurance.svg';
import { ReactComponent as Holdings } from './icon-holdings.svg';
import { ReactComponent as HomeLoan } from './icon-homeLoan.svg';
import { ReactComponent as HourGlass } from './icon-hourGlass.svg';
import { ReactComponent as Identity } from './icon-identity.svg';
import { ReactComponent as Image } from './icon-image.svg';
import { ReactComponent as Img } from './icon-img.svg';
import { ReactComponent as Income } from './icon-income.svg';
import { ReactComponent as IncomeTax } from './icon-incomeTax.svg';
import { ReactComponent as Inflation } from './icon-inflation.svg';
import { ReactComponent as Installment } from './icon-installment.svg';
import { ReactComponent as Insurance } from './icon-insurance.svg';
import { ReactComponent as InsuranceAgent } from './icon-insuranceAgent.svg';
import { ReactComponent as InsuranceVault } from './icon-insuranceVault.svg';
import { ReactComponent as International } from './icon-international.svg';
import { ReactComponent as InternationalFunds } from './icon-internationalFunds.svg';
import { ReactComponent as KnowledgeBase } from './icon-knowledgeBase.svg';
import { ReactComponent as LargeCap } from './icon-largeCap.svg';
import { ReactComponent as Learning } from './icon-learning.svg';
import { ReactComponent as Lending } from './icon-lending.svg';
import { ReactComponent as Like } from './icon-like.svg';
import { ReactComponent as Liquid } from './icon-liquid.svg';
import { ReactComponent as Loan } from './icon-loan.svg';
import { ReactComponent as Loan2 } from './icon-loan2.svg';
import { ReactComponent as LoanAgainstMf } from './icon-loanAgainstMf.svg';
import { ReactComponent as Logout } from './icon-logout.svg';
import { ReactComponent as Lumpsum } from './icon-lumpsum.svg';
import { ReactComponent as Marketing } from './icon-marketing.svg';
import { ReactComponent as MarketingPoster } from './icon-marketingPoster.svg';
import { ReactComponent as Megaphone } from './icon-megaphone.svg';
import { ReactComponent as MidCap } from './icon-midCap.svg';
import { ReactComponent as Mobile } from './icon-mobile.svg';
import { ReactComponent as MultiAsset } from './icon-multiAsset.svg';
import { ReactComponent as MultiCap } from './icon-multiCap.svg';
import { ReactComponent as MutualFunds } from './icon-mutualFunds.svg';
import { ReactComponent as New } from './icon-new.svg';
import { ReactComponent as NewClient } from './icon-newClient.svg';
import { ReactComponent as NewTransaction } from './icon-newTransaction.svg';
import { ReactComponent as News } from './icon-news.svg';
import { ReactComponent as Nfo } from './icon-nfo.svg';
import { ReactComponent as Nps } from './icon-nps.svg';
import { ReactComponent as Offer } from './icon-offer.svg';
import { ReactComponent as Opportunities } from './icon-opportunities.svg';
import { ReactComponent as Orders } from './icon-orders.svg';
import { ReactComponent as Overnight } from './icon-overnight.svg';
import { ReactComponent as Pdf } from './icon-pdf.svg';
import { ReactComponent as Pension } from './icon-pension.svg';
import { ReactComponent as Performance } from './icon-performance.svg';
import { ReactComponent as Portfolio } from './icon-portfolio.svg';
import { ReactComponent as PortfolioScanner } from './icon-portfolio_scanner.svg';
import { ReactComponent as Poster } from './icon-poster.svg';
import { ReactComponent as Ppt } from './icon-ppt.svg';
import { ReactComponent as Qrcode } from './icon-qrcode.svg';
import { ReactComponent as RealEstate } from './icon-realEstate.svg';
import { ReactComponent as Refer } from './icon-refer.svg';
import { ReactComponent as Report } from './icon-report.svg';
import { ReactComponent as Research } from './icon-research.svg';
import { ReactComponent as Returns } from './icon-returns.svg';
import { ReactComponent as Revenue } from './icon-revenue.svg';
import { ReactComponent as Reward2 } from './icon-reward-2.svg';
import { ReactComponent as Reward3 } from './icon-reward-3.svg';
import { ReactComponent as Reward } from './icon-reward.svg';
import { ReactComponent as RiskFactor } from './icon-riskFactor.svg';
import { ReactComponent as Savings } from './icon-savings.svg';
import { ReactComponent as Settings } from './icon-settings.svg';
import { ReactComponent as Sgb } from './icon-sgb.svg';
import { ReactComponent as Share } from './icon-share.svg';
import { ReactComponent as ShortTerm } from './icon-shortTerm.svg';
import { ReactComponent as SmallCap } from './icon-smallCap.svg';
import { ReactComponent as Stats } from './icon-stats.svg';
import { ReactComponent as Stocks } from './icon-stocks.svg';
import { ReactComponent as Tax } from './icon-tax.svg';
import { ReactComponent as Tax2 } from './icon-tax2.svg';
import { ReactComponent as TaxDoc2 } from './icon-taxDoc2.svg';
import { ReactComponent as TaxSavings } from './icon-taxSavings.svg';
import { ReactComponent as Tech } from './icon-tech.svg';
import { ReactComponent as TechSupport } from './icon-techSupport.svg';
import { ReactComponent as Term } from './icon-term.svg';
import { ReactComponent as TermInsurance } from './icon-termInsurance.svg';
import { ReactComponent as TermNew } from './icon-termNew.svg';
import { ReactComponent as Tick } from './icon-tick.svg';
import { ReactComponent as Time2 } from './icon-time2.svg';
import { ReactComponent as Top } from './icon-top.svg';
import { ReactComponent as TopFunds } from './icon-topFunds.svg';
import { ReactComponent as Track } from './icon-track.svg';
import { ReactComponent as TrackingInvestments } from './icon-trackingInvestments.svg';
import { ReactComponent as Trading } from './icon-trading.svg';
import { ReactComponent as Training } from './icon-training.svg';
import { ReactComponent as Transaction } from './icon-transaction.svg';
import { ReactComponent as TransactionHistory } from './icon-transactionHistory.svg';
import { ReactComponent as Translate } from './icon-translate.svg';
import { ReactComponent as TravelInsurance } from './icon-travelInsurance.svg';
import { ReactComponent as TreasuryBonds } from './icon-treasuryBonds.svg';
import { ReactComponent as Unique } from './icon-unique.svg';
import { ReactComponent as User } from './icon-user.svg';
import { ReactComponent as Vault } from './icon-vault.svg';
import { ReactComponent as Video } from './icon-video.svg';
import { ReactComponent as Warning } from './icon-warning.svg';
import { ReactComponent as Webinar } from './icon-webinar.svg';
import { ReactComponent as Withdrawal } from './icon-withdrawal.svg';
import { ReactComponent as Xls } from './icon-xls.svg';

export type ColouredSVGIcon = "corporateBond" | "docs" | "home" | "iPO" | "money" | "money2" | "nominee" | "onlineEmpanelment" | "protection" | "review" | "sIPs" | "sTPs" | "sWPs" | "watchlist" | "addClient" | "advisor" | "aggressiveHybrid" | "analysis" | "arbitrage" | "balance" | "balancedAdvantage" | "bank" | "bank2" | "bikeInsurance" | "bizGuru" | "brokerage" | "businessLoan" | "buyAPolicy" | "calculator" | "calendar" | "car" | "carInsurance" | "carLoan" | "casUpload" | "cash" | "chair" | "channelPlus" | "chart" | "claimCentre" | "coinStack" | "commodities" | "compare" | "compare2" | "compareFunds" | "comparePolicies" | "conservative" | "conservativeHybrid" | "cross" | "csvUpload" | "customerSupport" | "digikyc" | "dividend" | "dividendYield" | "doc" | "educationLoan" | "expertSupport" | "explore" | "faq" | "faq2" | "filter" | "fixedDeposit" | "flexiCap" | "flexible" | "focus" | "friendly" | "fundFinder" | "gift" | "goal" | "gold" | "graduateBoy" | "graduateGirl" | "graduationBoy" | "graduationGirl" | "health" | "healthInsurance" | "holdings" | "homeLoan" | "hourGlass" | "identity" | "image" | "img" | "income" | "incomeTax" | "inflation" | "installment" | "insurance" | "insuranceAgent" | "insuranceVault" | "international" | "internationalFunds" | "knowledgeBase" | "largeCap" | "learning" | "lending" | "like" | "liquid" | "loan" | "loan2" | "loanAgainstMf" | "logout" | "lumpsum" | "marketing" | "marketingPoster" | "megaphone" | "midCap" | "mobile" | "multiAsset" | "multiCap" | "mutualFunds" | "new" | "newClient" | "newTransaction" | "news" | "nfo" | "nps" | "offer" | "opportunities" | "orders" | "overnight" | "pdf" | "pension" | "performance" | "portfolio" | "portfolio_scanner" | "poster" | "ppt" | "qrcode" | "realEstate" | "refer" | "report" | "research" | "returns" | "revenue" | "reward2" | "reward3" | "reward" | "riskFactor" | "savings" | "settings" | "sgb" | "share" | "shortTerm" | "smallCap" | "stats" | "stocks" | "tax" | "tax2" | "taxDoc2" | "taxSavings" | "tech" | "techSupport" | "term" | "termInsurance" | "termNew" | "tick" | "time2" | "top" | "topFunds" | "track" | "trackingInvestments" | "trading" | "training" | "transaction" | "transactionHistory" | "translate" | "travelInsurance" | "treasuryBonds" | "unique" | "user" | "vault" | "video" | "warning" | "webinar" | "withdrawal" | "xls"; 


export const ColouredSVGIconNames = ["corporateBond", "docs", "home", "iPO", "money", "money2", "nominee", "onlineEmpanelment", "protection", "review", "sIPs", "sTPs", "sWPs", "watchlist", "addClient", "advisor", "aggressiveHybrid", "analysis", "arbitrage", "balance", "balancedAdvantage", "bank", "bank2", "bikeInsurance", "bizGuru", "brokerage", "businessLoan", "buyAPolicy", "calculator", "calendar", "car", "carInsurance", "carLoan", "casUpload", "cash", "chair", "channelPlus", "chart", "claimCentre", "coinStack", "commodities", "compare", "compare2", "compareFunds", "comparePolicies", "conservative", "conservativeHybrid", "cross", "csvUpload", "customerSupport", "digikyc", "dividend", "dividendYield", "doc", "educationLoan", "expertSupport", "explore", "faq", "faq2", "filter", "fixedDeposit", "flexiCap", "flexible", "focus", "friendly", "fundFinder", "gift", "goal", "gold", "graduateBoy", "graduateGirl", "graduationBoy", "graduationGirl", "health", "healthInsurance", "holdings", "homeLoan", "hourGlass", "identity", "image", "img", "income", "incomeTax", "inflation", "installment", "insurance", "insuranceAgent", "insuranceVault", "international", "internationalFunds", "knowledgeBase", "largeCap", "learning", "lending", "like", "liquid", "loan", "loan2", "loanAgainstMf", "logout", "lumpsum", "marketing", "marketingPoster", "megaphone", "midCap", "mobile", "multiAsset", "multiCap", "mutualFunds", "new", "newClient", "newTransaction", "news", "nfo", "nps", "offer", "opportunities", "orders", "overnight", "pdf", "pension", "performance", "portfolio", "portfolio_scanner", "poster", "ppt", "qrcode", "realEstate", "refer", "report", "research", "returns", "revenue", "reward2", "reward3", "reward", "riskFactor", "savings", "settings", "sgb", "share", "shortTerm", "smallCap", "stats", "stocks", "tax", "tax2", "taxDoc2", "taxSavings", "tech", "techSupport", "term", "termInsurance", "termNew", "tick", "time2", "top", "topFunds", "track", "trackingInvestments", "trading", "training", "transaction", "transactionHistory", "translate", "travelInsurance", "treasuryBonds", "unique", "user", "vault", "video", "warning", "webinar", "withdrawal", "xls"];

function getIcon(icon: ColouredSVGIcon) {
    switch (icon) {
   case "corporateBond": return <CorporateBond />;
   case "docs": return <Docs />;
   case "home": return <Home />;
   case "iPO": return <IPO />;
   case "money": return <Money />;
   case "money2": return <Money2 />;
   case "nominee": return <Nominee />;
   case "onlineEmpanelment": return <OnlineEmpanelment />;
   case "protection": return <Protection />;
   case "review": return <Review />;
   case "sIPs": return <SIPs />;
   case "sTPs": return <STPs />;
   case "sWPs": return <SWPs />;
   case "watchlist": return <Watchlist />;
   case "addClient": return <AddClient />;
   case "advisor": return <Advisor />;
   case "aggressiveHybrid": return <AggressiveHybrid />;
   case "analysis": return <Analysis />;
   case "arbitrage": return <Arbitrage />;
   case "balance": return <Balance />;
   case "balancedAdvantage": return <BalancedAdvantage />;
   case "bank": return <Bank />;
   case "bank2": return <Bank2 />;
   case "bikeInsurance": return <BikeInsurance />;
   case "bizGuru": return <BizGuru />;
   case "brokerage": return <Brokerage />;
   case "businessLoan": return <BusinessLoan />;
   case "buyAPolicy": return <BuyAPolicy />;
   case "calculator": return <Calculator />;
   case "calendar": return <Calendar />;
   case "car": return <Car />;
   case "carInsurance": return <CarInsurance />;
   case "carLoan": return <CarLoan />;
   case "casUpload": return <CasUpload />;
   case "cash": return <Cash />;
   case "chair": return <Chair />;
   case "channelPlus": return <ChannelPlus />;
   case "chart": return <Chart />;
   case "claimCentre": return <ClaimCentre />;
   case "coinStack": return <CoinStack />;
   case "commodities": return <Commodities />;
   case "compare": return <Compare />;
   case "compare2": return <Compare2 />;
   case "compareFunds": return <CompareFunds />;
   case "comparePolicies": return <ComparePolicies />;
   case "conservative": return <Conservative />;
   case "conservativeHybrid": return <ConservativeHybrid />;
   case "cross": return <Cross />;
   case "csvUpload": return <CsvUpload />;
   case "customerSupport": return <CustomerSupport />;
   case "digikyc": return <Digikyc />;
   case "dividend": return <Dividend />;
   case "dividendYield": return <DividendYield />;
   case "doc": return <Doc />;
   case "educationLoan": return <EducationLoan />;
   case "expertSupport": return <ExpertSupport />;
   case "explore": return <Explore />;
   case "faq": return <Faq />;
   case "faq2": return <Faq2 />;
   case "filter": return <Filter />;
   case "fixedDeposit": return <FixedDeposit />;
   case "flexiCap": return <FlexiCap />;
   case "flexible": return <Flexible />;
   case "focus": return <Focus />;
   case "friendly": return <Friendly />;
   case "fundFinder": return <FundFinder />;
   case "gift": return <Gift />;
   case "goal": return <Goal />;
   case "gold": return <Gold />;
   case "graduateBoy": return <GraduateBoy />;
   case "graduateGirl": return <GraduateGirl />;
   case "graduationBoy": return <GraduationBoy />;
   case "graduationGirl": return <GraduationGirl />;
   case "health": return <Health />;
   case "healthInsurance": return <HealthInsurance />;
   case "holdings": return <Holdings />;
   case "homeLoan": return <HomeLoan />;
   case "hourGlass": return <HourGlass />;
   case "identity": return <Identity />;
   case "image": return <Image />;
   case "img": return <Img />;
   case "income": return <Income />;
   case "incomeTax": return <IncomeTax />;
   case "inflation": return <Inflation />;
   case "installment": return <Installment />;
   case "insurance": return <Insurance />;
   case "insuranceAgent": return <InsuranceAgent />;
   case "insuranceVault": return <InsuranceVault />;
   case "international": return <International />;
   case "internationalFunds": return <InternationalFunds />;
   case "knowledgeBase": return <KnowledgeBase />;
   case "largeCap": return <LargeCap />;
   case "learning": return <Learning />;
   case "lending": return <Lending />;
   case "like": return <Like />;
   case "liquid": return <Liquid />;
   case "loan": return <Loan />;
   case "loan2": return <Loan2 />;
   case "loanAgainstMf": return <LoanAgainstMf />;
   case "logout": return <Logout />;
   case "lumpsum": return <Lumpsum />;
   case "marketing": return <Marketing />;
   case "marketingPoster": return <MarketingPoster />;
   case "megaphone": return <Megaphone />;
   case "midCap": return <MidCap />;
   case "mobile": return <Mobile />;
   case "multiAsset": return <MultiAsset />;
   case "multiCap": return <MultiCap />;
   case "mutualFunds": return <MutualFunds />;
   case "new": return <New />;
   case "newClient": return <NewClient />;
   case "newTransaction": return <NewTransaction />;
   case "news": return <News />;
   case "nfo": return <Nfo />;
   case "nps": return <Nps />;
   case "offer": return <Offer />;
   case "opportunities": return <Opportunities />;
   case "orders": return <Orders />;
   case "overnight": return <Overnight />;
   case "pdf": return <Pdf />;
   case "pension": return <Pension />;
   case "performance": return <Performance />;
   case "portfolio": return <Portfolio />;
   case "portfolio_scanner": return <PortfolioScanner />;
   case "poster": return <Poster />;
   case "ppt": return <Ppt />;
   case "qrcode": return <Qrcode />;
   case "realEstate": return <RealEstate />;
   case "refer": return <Refer />;
   case "report": return <Report />;
   case "research": return <Research />;
   case "returns": return <Returns />;
   case "revenue": return <Revenue />;
   case "reward2": return <Reward2 />;
   case "reward3": return <Reward3 />;
   case "reward": return <Reward />;
   case "riskFactor": return <RiskFactor />;
   case "savings": return <Savings />;
   case "settings": return <Settings />;
   case "sgb": return <Sgb />;
   case "share": return <Share />;
   case "shortTerm": return <ShortTerm />;
   case "smallCap": return <SmallCap />;
   case "stats": return <Stats />;
   case "stocks": return <Stocks />;
   case "tax": return <Tax />;
   case "tax2": return <Tax2 />;
   case "taxDoc2": return <TaxDoc2 />;
   case "taxSavings": return <TaxSavings />;
   case "tech": return <Tech />;
   case "techSupport": return <TechSupport />;
   case "term": return <Term />;
   case "termInsurance": return <TermInsurance />;
   case "termNew": return <TermNew />;
   case "tick": return <Tick />;
   case "time2": return <Time2 />;
   case "top": return <Top />;
   case "topFunds": return <TopFunds />;
   case "track": return <Track />;
   case "trackingInvestments": return <TrackingInvestments />;
   case "trading": return <Trading />;
   case "training": return <Training />;
   case "transaction": return <Transaction />;
   case "transactionHistory": return <TransactionHistory />;
   case "translate": return <Translate />;
   case "travelInsurance": return <TravelInsurance />;
   case "treasuryBonds": return <TreasuryBonds />;
   case "unique": return <Unique />;
   case "user": return <User />;
   case "vault": return <Vault />;
   case "video": return <Video />;
   case "warning": return <Warning />;
   case "webinar": return <Webinar />;
   case "withdrawal": return <Withdrawal />;
   case "xls": return <Xls />;
default:
            return <div></div>
    }
}

interface APColouredIconProps {
    icon: ColouredSVGIcon,
    /**
     * @default 24
     */
    size?: number,
}

export function APColouredIcon({ icon, size = 24 }: APColouredIconProps) {
    return React.cloneElement(getIcon(icon), { width: size, height: size })
}
